import moment from 'moment'
import 'moment/dist/locale/pl'
import {storeToRefs} from "pinia";
import {useSectionsStore} from "@/stores/section";
moment.locale('pl')

const sectionsStore = useSectionsStore()
const { pageSettingType } = storeToRefs(sectionsStore)

export const useUtils = () => {
  const parseImageUrl = (url, width, height) => {
    if (url) {
      return url.replace('{width}', width).replace('{height}', height)
    }
    return ''
  }

  const formatDate = (timelinedate) => moment(timelinedate).format('L')
  const formatOnlyDate = (timelinedate) => moment(timelinedate).format("DD.MM.YYYY")

  const formatDateToTime = (timelinedate) => moment(timelinedate).format('LT')

  const formatDateTvProgram = (timelinedate) => moment(timelinedate).format('LL')
  const formatDayTvProgram = (timelinedate) => moment(timelinedate).format('dddd')

  const currentYear = (timelinedate) => moment(timelinedate).year()

  // Program TV Filter data
  const formatDaytoName = (timelinedate) => moment(timelinedate).subtract(1, 'days').format('dddd')
  const formatOneDayAgo = (timelinedate) => moment(timelinedate).subtract(1, 'days').format('DD.MM')

  const formatNameDayToday = (timelinedate) => moment(timelinedate).format('dddd')
  const formatDayToday = (timelinedate) => moment(timelinedate).format('DD.MM')
  const formatDataToday = (timelinedate) => moment(timelinedate).format('YYYY-MM-DD')

  const dayShortcut = (timelinedate) => moment(timelinedate).format('dddd').substring(0, 3)

  const truncateTextToFirstDot = (text) => text?.substr(0, text.indexOf('.') + 1) ?? text

  const truncateText = (text, size) => {
    return text?.length > size ?? text ? text?.slice(0, size - 1) + '…' : text
  }

  const isCurrent = (start, end) => {
    const currentTime = new Date().getTime()
    return !!(currentTime > start && currentTime < end)
  }

  const getStartTime = (item) => {
    if (isCurrent(item.date_start, item.date_end)) {
      return 'TRWA'
    }
    const timestamp = item.date_start
    const date = new Date(timestamp)
    const hour = date.getHours()
    const minutes = ('0' + date.getMinutes()).slice(-2)
    return `${hour}:${minutes}`
  }

  const darkenHexColor = (hex, percent) => {
    // Sprawdzenie czy kolor HEX zaczyna się od '#'
    if (hex.charAt(0) === '#') {
      hex = hex.slice(1);
    }

    // Długość koloru HEX powinna wynosić 6 (bez '#')
    if (hex.length !== 6) {
      throw new Error('Nieprawidłowy kolor HEX');
    }

    let rgb = '';
    for (let i = 0; i < 6; i += 2) {
      // Konwersja dwóch znaków HEX na liczbę dziesiętną
      let decimalValue = parseInt(hex.substr(i, 2), 16);
      // Przyciemnienie koloru o podany procent
      decimalValue = Math.floor(decimalValue * (1 - percent));
      // Zapewnienie, że wartość nie spadnie poniżej 0
      decimalValue = Math.max(0, decimalValue);
      // Konwersja liczby dziesiętnej z powrotem na HEX
      let hexValue = decimalValue.toString(16);
      // Dopisanie zera na początku, jeśli wartość HEX ma tylko jeden znak
      rgb += hexValue.length === 1 ? '0' + hexValue : hexValue;
    }

    return '#' + rgb;
  }

  const getArticleTitle = (context) => {
    return (context?.title_sg && pageSettingType.value === 'SG') ? context?.title_sg : context?.title
  }

  return {
    parseImageUrl,
    truncateTextToFirstDot,
    isCurrent,
    getStartTime,
    formatDateToTime,
    truncateText,
    formatDate,
    formatDateTvProgram,
    formatDayTvProgram,
    currentYear,
    formatOneDayAgo,
    formatDaytoName,
    formatNameDayToday,
    formatDayToday,
    formatDataToday,
    dayShortcut,
    formatOnlyDate,
    darkenHexColor,
    getArticleTitle
  }
}
